import { Component, Input } from '@angular/core';

@Component({
    selector: 'localidade',
    templateUrl: './localidade.component.html',
    styleUrls: ['./localidade.component.scss'],
})
export class LocalidadeComponent {

    @Input() darkMode: boolean;
    @Input() localidade: any;
    @Input() showArrow: boolean;
    @Input() selecionado: boolean;

    getEndereco() {
        return this.localidade.endereco ? this.localidade.endereco : '';
    }
}
